<template>
    <div class="sidebar" :class="{'sidebar-closed': $store.getters['sidebar/getSidebar']}">
        <div class="sidebar-wrapper">
            <div class="logo" @click.stop.prevent="toggleSidebar">
                <router-link to="/painel-administrativo" class="simple-text logo-mini">
                    <img src="/img/logo/ugt_logo.png"
                         alt="UGT-SP">
                </router-link>
            </div>
            <aside class="sidebar-nav"
                   :class="{'sidebar-closed': $store.getters['sidebar/getSidebar']}">

                <sidebar-link name="Painel Administrativo" to="/painel-administrativo"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <svg-icon icon="dashboard"></svg-icon>
                </sidebar-link>

                <sidebar-link name="Lista de Eventos" to="/sistema/eventos/lista-eventos"
                              v-if="$store.getters['user/getUser']['tipo'] === 2">
                    <svg-icon icon="eventos"></svg-icon>
                </sidebar-link>

                <sidebar-link name="Eventos" :dropdown="true" :links="linksEventos"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/sistema/eventos/lista-eventos"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="eventos"></svg-icon>
                    </router-link>
                    <svg-icon icon="eventos" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Sindicatos" :dropdown="true" :links="linksSindicatos"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/sistema/sindicatos/lista-sindicatos"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="sindicatos"></svg-icon>
                    </router-link>
                    <svg-icon icon="sindicatos" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Notícias" :dropdown="true" :links="linksnoticias"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/sistema/noticias/lista-noticias"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="noticias"></svg-icon>
                    </router-link>
                    <svg-icon icon="noticias" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Financeiro" :dropdown="true" :links="linksfinanceiro"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/financeiro/inadimplentes"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="financeiro"></svg-icon>
                    </router-link>
                    <svg-icon icon="financeiro" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Publicações" :dropdown="true" :links="linkspublicacoes"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/sistema/publicacoes/lista-publicacoes"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="publish"></svg-icon>
                    </router-link>
                    <svg-icon icon="publish" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Vídeos" :dropdown="true" :links="linksVideos"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <router-link to="/sistema/videos/lista-videos"
                                 v-if="$store.getters['sidebar/getSidebar']"
                                 class="svg-closed-navbar">
                        <svg-icon icon="video"></svg-icon>
                    </router-link>
                    <svg-icon icon="video" v-else></svg-icon>
                </sidebar-link>

                <sidebar-link name="Lista de Newsletter" to="/sistema/newsletter/lista-newsletter"
                              v-if="$store.getters['user/getUser']['tipo'] !== 2">
                    <svg-icon icon="newsletter"></svg-icon>
                </sidebar-link>

                <button @click="logout" class="logout">
                    <svg-icon icon="exit" class="text-xl mr-2"/>
                    Sair do Sistema
                </button>

            </aside>
        </div>
    </div>
</template>
<script>
import {forEach} from 'lodash';
import sidebarLink from './sidebar-link';

export default {
    name: 'sidebar',
    components: {
        sidebarLink
    },
    data() {
        return {
            linksEventos: [
                {
                    to: '/sistema/eventos/novo-evento',
                    name: 'Novo Evento'
                },
                {
                    to: '/sistema/eventos/lista-eventos',
                    name: 'Lista de Evento'
                },
                {
                    to: '/sistema/eventos/lista-contatos',
                    name: 'Lista de Contatos'
                }
            ],
            linksSindicatos: [
                {
                    to: '/sistema/sindicatos/novo-sindicato',
                    name: 'Novo Sindicato'
                },
                {
                    to: '/sistema/sindicatos/lista-sindicatos',
                    name: 'Lista de Sindicatos'
                },
            ],
            linksnoticias: [
                {
                    to: '/sistema/noticias/nova-noticia',
                    name: 'Nova Notícia'
                },
                {
                    to: '/sistema/noticias/lista-noticias',
                    name: 'Lista de Notícias'
                },
            ],
            linksfinanceiro: [
                {
                    to: '/sistema/financeiro/inadimplentes',
                    name: 'Inadimplentes',
                },
                {
                    to: '/sistema/boletos/lista-boletos',
                    name: 'Lista Boletos '
                },
                {
                    to: '/sistema/boletos/configuracoes-boleto',
                    name: 'Configurações Boleto '
                },

            ],
            linkspublicacoes: [
                {
                    to: '/sistema/publicacoes/nova-publicacao',
                    name: 'Nova Publicação'
                },
                {
                    to: '/sistema/publicacoes/lista-publicacoes',
                    name: 'Lista de Publicações'
                },
            ],
            linksVideos: [
                {
                    to: '/sistema/videos/novo-video',
                    name: 'Novo Vídeo'
                },
                {
                    to: '/sistema/videos/lista-videos',
                    name: 'Lista de Vídeos'
                },
            ],
        }
    },
    methods: {
        /**
         * Abre a sidebar
         */
        openSidebar() {
            this.$store.commit('sidebar/openSidebar');
        },

        /**
         * Fecha a sidebar
         */
        closeSidebar() {
            this.$store.commit('sidebar/closeSidebar');
        },
        /**
         * Fecha a sidebar no responsivo
         */
        toggleSidebar() {
            this.$store.commit('sidebar/toggleSidebar');
        },

        logout() {
            this.$store.dispatch('user/do_reset_user').then(() => {
                this.$store.commit('auth/destroyToken');
                this.$router.push('/');
            })
        },
    }
};
</script>

<style lang="scss" scoped>
.sidebar-wrapper::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
}

.sidebar-wrapper::-webkit-scrollbar
{
    width: 5px;
    background-color: #F5F5F5;
}

.sidebar-wrapper::-webkit-scrollbar-thumb
{
    background-color: red;
}

.sidebar {
    @apply fixed block h-screen left-0 right-auto m-0 rounded-none
    p-0 z-50 bg-primary;
    top: 70px;
    width: 230px;
    //background: #FDC830; /* fallback for old browsers */
    //background: -webkit-linear-gradient(to right, #F37335, #FDC830); /* Chrome 10-25, Safari 5.1-6 */
    //background: linear-gradient(to right, #F37335, #FDC830); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);
    -webkit-transform: translate3d(-260px, 0, 0);
    transform: translate3d(-260px, 0, 0);
    -webkit-box-shadow: 0 2px 22px 0 rgba(0, 0, 0, .1), 0 4px 20px 0 rgba(0, 0, 0, .15);
    box-shadow: 0 2px 22px 0 rgba(0, 0, 0, .1), 0 4px 20px 0 rgba(0, 0, 0, .15);

    @media(min-width: 1024px) {
        @apply fixed top-0 left-0 rounded;
        width: 80px;
        height: calc(100vh - 100px);
        margin-top: 90px;
        margin-left: 20px;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);

        &:before {
            @apply absolute;
            content: "";
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid #e6242c;
            top: -5px;
            left: 42px;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
        }
    }

    .sidebar-wrapper {
        @apply .h-screen .overflow-x-hidden;

        @media(min-width: 1024px) {
            @apply .relative .w-full .min-h-full .overflow-y-auto;
            max-height: calc(100vh - 705px);
        }
    }

    .logo {
        @apply .relative .flex .items-center justify-center pt-2 px-3 pb-4 bg-white;

        //Monta o divisor da sidebar
        &:after {
            @apply .absolute .bottom-0 .bg-white;
            content: "";
            right: 15px;
            height: 1px;
            width: calc(100% - 30px);
        }

        .simple-text {
            @apply .block .uppercase .py-2 .whitespace-no-wrap .text-xs .text-white .font-semibold .overflow-hidden;
            line-height: 30px;
        }

        .logo-mini {
            @apply .opacity-100 .float-left .text-center;
            width: 60px;
            min-width: 60px;
            margin: 0 12px;

            img {
                @apply .bg-white .rounded-full .max-w-full;
            }
        }


        .logo-normal {
            @apply .opacity-100 .text-white .text-xs .uppercase  .py-2 .overflow-hidden .no-underline;
            line-height: 30px;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
        }
    }
}

.sidebar.sidebar-closed {
    -webkit-transition: .5s cubic-bezier(.685, .0473, .346, 1);
    transition: .5s cubic-bezier(.685, .0473, .346, 1);
    -webkit-transform: translateZ(0);
    transform: translateZ(0);

    @media(min-width: 1024px) {
        width: 230px;
    }

    &::v-deep .sidebar-link {
        .link-name {
            @media(min-width: 1024px) {
                @apply opacity-100;
            }
        }
    }

    &::v-deep .sidebar-dropdown {
        .link-name {
            @media(min-width: 1024px) {
                @apply opacity-100;
            }
        }
    }

    &::v-deep .sidebar-dropdown {
        .sidebar-dropdown-links {
            @media(min-width: 1024px) {
                @apply block opacity-100;
            }
        }
    }
}

.sidebar-nav {
    @apply .block .mt-8 .px-2;

    .svg-closed-navbar {
        @apply m-0 p-0;
    }

    .logout {
        @apply flex font-medium text-white px-5 items-center w-full absolute;
        bottom: 90px;
        @media(min-width: 1024px) {
            display: none;
        }
    }
}

.sidebar-nav {
    &::v-deep .sidebar-link {
        .link-name {
            @media(min-width: 1024px) {
                @apply opacity-0;
            }
        }

        //& > a.router-link-active {
        //    &:before {
        //        content: none;
        //    }
        //}
    }

    &::v-deep .sidebar-dropdown {
        .link-name {
            @media(min-width: 1024px) {
                @apply opacity-0;
            }
        }
    }

    &::v-deep .sidebar-dropdown {
        .sidebar-dropdown-links {
            @media(min-width: 1024px) {
                @apply hidden opacity-0;
            }
        }
    }
}
</style>
